import axios from "axios";
import { config } from "../config";
import { UserSessionRequest } from "../models/requests/UserSessionRequest";
import { SessionTitleRequest } from "../models/requests/SessionTitleRequest";
import { getAuthHeader } from "../customAuth/authContext";
import { sleep } from "../infrastructures/utils";

const backendUrl = `${config.pythonApiUrl}/user-session`;


export const addUserSession = async (userSessionRequest: UserSessionRequest) => {
    const response = await axios.post(`${backendUrl}/add`, userSessionRequest, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: getAuthHeader()
        }
    })
        .catch((error) => {
            console.error("Error making post request", error.response);
        })

    return response;
}

export const getUserSessions = async (userEmail: string) => {
    let attempts = 0;
    const maxRetries = 3;
    const url = `${config.pythonApiUrl}/user-session/all`;
    const request = { user_email: userEmail };

    while (attempts < maxRetries) {
        try {
            const response = await axios.get(url, {
                params: request,
                headers: {
                    Authorization: getAuthHeader()
                }
            });

            if (response?.status === 200) {
                return response;
            }
        } catch (error) {
            console.error(`Error on attempt ${attempts + 1}:`, error);
        }

        attempts++;
        if (attempts < maxRetries) {
            await sleep(1000 * attempts);
        }
    }

    console.error("All attempts failed or returned no data");
    return null;
}


export const updateUserSession = async (userSessionRequest: UserSessionRequest) => {
    try {
        const response = await axios.put(`${backendUrl}/update`, userSessionRequest,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getAuthHeader()
                }
            }
        );
        return response;
    } catch (error: any) {
        console.error("Error making put request", error);
        throw error;
    }
};

export const updateUserSessionCollection = async (userSessionRequest: UserSessionRequest) => {
    const response = await axios.put(`${backendUrl}/update-session-collection`, userSessionRequest, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: getAuthHeader()
        }
    })
    return response.data;
}


export const deleteUserSession = async (user_email: string, sessionId: string) => {
    const response = await axios.delete(`${backendUrl}/delete?user_email=${user_email}&session_id=${sessionId}`, {
        headers: {
            Authorization: getAuthHeader()
        }
    })
        .catch((error) => {
            console.error("Error making delete request", error.response);
        })

    return response;
}

export const generateSessionTitle = async (request: SessionTitleRequest) => {
    const response = await axios.post(`${backendUrl}/generate-session-title`, request, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: getAuthHeader()
        }
    })
        .catch((error) => {
            console.error("Error making post request", error.response);
        })
    return response;
}